(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["homzefy-offer"] && !Shopify.designMode) return;
  try {
    document.addEventListener('submit', async (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.matches('[data-hz-offer]')) return;
    event.preventDefault();
    const button = form.querySelector('button');
    if (button.disabled) return;
    const error = form.querySelector('[role="alert"]');
    error.hidden = true;
    button.disabled = true;
    form.setAttribute('aria-busy', 'true');
    try {
      const response = await fetch(form.action + '.js', {method: 'POST', body: new FormData(form), headers: {'Accept': 'application/json'}});
      const data = await response.json();
      if (!response.ok) throw new Error(typeof data.description === 'string' ? data.description : error.dataset.error);
      window.location.assign(form.dataset.cartUrl);
    } catch (failure) {
      error.textContent = failure.message || error.dataset.error;
      error.hidden = false;
      button.disabled = false;
      form.removeAttribute('aria-busy');
    }
  });
  } catch(e) { console.error(e); }
})();

})();
